import styled from 'styled-components';
import { PublicPageLayout } from '../components/PublicPageLayout';

const Section = styled.section`
  margin-bottom: ${({ theme }) => theme.spacing.xl};
`;

const SectionTitle = styled.h2`
  font-size: ${({ theme }) => theme.fontSize.xl};
  font-weight: ${({ theme }) => theme.fontWeight.semibold};
  color: ${({ theme }) => theme.colors.text};
  margin-bottom: ${({ theme }) => theme.spacing.md};
`;

const Paragraph = styled.p`
  font-size: ${({ theme }) => theme.fontSize.md};
  color: ${({ theme }) => theme.colors.textSecondary};
  line-height: 1.7;
  margin-bottom: ${({ theme }) => theme.spacing.md};
`;

const List = styled.ul`
  margin: 0 0 ${({ theme }) => theme.spacing.md} ${({ theme }) => theme.spacing.lg};
  color: ${({ theme }) => theme.colors.textSecondary};
  line-height: 1.7;

  li { margin-bottom: ${({ theme }) => theme.spacing.xs}; }
`;

const Updated = styled.p`
  font-size: ${({ theme }) => theme.fontSize.sm};
  color: ${({ theme }) => theme.colors.textMuted};
  margin-top: -${({ theme }) => theme.spacing.lg};
  margin-bottom: ${({ theme }) => theme.spacing.xl};
`;

export function TermsPage() {
  return (
    <PublicPageLayout
      title="Terms of Service"
      subtitle="The conditions under which you use Coopen SMM."
    >
      <Updated>Last updated: May 3, 2026</Updated>

      <Section>
        <SectionTitle>1. Acceptance</SectionTitle>
        <Paragraph>
          By creating an account or using Coopen SMM, you accept these terms. If you do not agree,
          you may not use the service.
        </Paragraph>
      </Section>

      <Section>
        <SectionTitle>2. Accounts</SectionTitle>
        <Paragraph>
          You are responsible for keeping your credentials secure and for all activity that occurs
          under your account. Notify us immediately if you suspect unauthorized access.
        </Paragraph>
      </Section>

      <Section>
        <SectionTitle>3. Acceptable use</SectionTitle>
        <Paragraph>You may not use Coopen SMM to:</Paragraph>
        <List>
          <li>Generate illegal, fraudulent, defamatory content, or content that violates third-party rights.</li>
          <li>Produce misinformation, non-consensual sexual content, or material that incites hatred.</li>
          <li>Reverse-engineer, scrape, or overload the platform.</li>
          <li>Resell the service without a written agreement with Coopen.</li>
        </List>
      </Section>

      <Section>
        <SectionTitle>4. Content ownership</SectionTitle>
        <Paragraph>
          The content you generate with Coopen SMM is yours. We retain the rights to the code,
          the platform templates, and the Coopen brand. Stock images are governed by the
          Unsplash or Pexels license as applicable.
        </Paragraph>
      </Section>

      <Section>
        <SectionTitle>5. Credits and billing</SectionTitle>
        <Paragraph>
          Generations consume credits according to your plan. Unused credits may not be
          refundable. We may change prices with 30 days' notice by email; changes
          apply starting from the next billing cycle.
        </Paragraph>
      </Section>

      <Section>
        <SectionTitle>6. Availability</SectionTitle>
        <Paragraph>
          We do our best to keep the platform available 24/7, but we do not guarantee that
          it is free of errors or interruptions. Scheduled maintenance is announced in
          advance whenever possible.
        </Paragraph>
      </Section>

      <Section>
        <SectionTitle>7. Suspension and termination</SectionTitle>
        <Paragraph>
          We may suspend or close accounts that violate these terms, after notifying you
          (except in urgent security or legal cases). You can close your account at any
          time from the settings.
        </Paragraph>
      </Section>

      <Section>
        <SectionTitle>8. Limitation of liability</SectionTitle>
        <Paragraph>
          Coopen SMM is provided "as is". We are not liable for indirect damages, lost profits,
          or data loss arising from the use of the platform, to the maximum extent permitted by
          applicable law.
        </Paragraph>
      </Section>

      <Section>
        <SectionTitle>9. Changes to the terms</SectionTitle>
        <Paragraph>
          If we update these terms, we will notify you by email at least 14 days in
          advance. If you continue using the service after the effective date, you accept the
          updated terms.
        </Paragraph>
      </Section>

      <Section>
        <SectionTitle>10. Contact</SectionTitle>
        <Paragraph>
          For any questions about these terms, write to us at{' '}
          <a href="mailto:coopenstudio@gmail.com">coopenstudio@gmail.com</a>.
        </Paragraph>
      </Section>
    </PublicPageLayout>
  );
}
